// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Định dạng cho phần tiêu đề */
h1 {
  color: #333;
  font-size: 28px;
  margin-bottom: 20px;
  text-align: center;
  /* Căn giữa tiêu đề */
}
.gradient-text {
  background: linear-gradient(45deg, #ff5733, #96a2ff); /* Gradient colors */
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent; /* Đặt màu chữ trở thành trong suốt */
}

/* Định dạng cho phần chính của ứng dụng */

.centered-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  width: 100%;
}

/* Định dạng cho trường nhập liệu */
input[type="file"] {
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 10px;
  max-width: 400px;
  /* Giới hạn độ rộng của trường nhập liệu */
}

/* Định dạng cho các trường nhập liệu và nút */
TextField,
Button {
  margin: 10px;
  max-width: 400px;
  /* Giới hạn độ rộng của trường nhập liệu và nút */
}

/* Định dạng cho nút "Xuất" */
Button {
  background-color: #0073e6;
  color: #fff;
  font-size: 16px;
  padding: 10px 20px;
  border: none;
  cursor: pointer;
  transition: background-color 0.3s;
  /* Hiệu ứng chuyển đổi màu nền */
}

Button:hover {
  background-color: #005bbb;
  /* Màu nền khi di chuột qua nút */
}

/* Định dạng cho trường nhập liệu */

/* Định dạng cho nội dung của các trường nhập liệu */
.MuiInputBase-input {
  padding: 10px;
  border: 1px solid #ccc;
}

/* Định dạng cho nhãn của trường nhập liệu */
.MuiInputLabel-root {
  color: #333;
}

/* Định dạng cho đường viền khi trường nhập liệu được tập trung */
.Mui-focused {
  border-color: #0073e6;
  e: \\Nodejs + React\\Front-End - Copy\\.env
}

/* Thiết lập kiểu cho phần giới tính */
.gender {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

/* Thiết lập kiểu cho danh sách sản phẩm của Nam */
.male {
  border-radius: 10px;
  background-color: #b3e0ff;
  border: 1px solid #3498db;
  padding: 10px;
  margin: 5px;
  text-align: center;
  width: 500;
}

.male h2 {
  color: #3498db;
  margin: -10px;
  margin-bottom: -20px;
}

.male ul {
  list-style-type: none;
  padding: 0;
}

@keyframes sf-fly-by-1 {
  from {
    transform: translateZ(-600px);
    opacity: 0.5;
  }

  to {
    transform: translateZ(0);
    opacity: 0.5;
  }
}

@keyframes sf-fly-by-2 {
  from {
    transform: translateZ(-1200px);
    opacity: 0.5;
  }

  to {
    transform: translateZ(-600px);
    opacity: 0.5;
  }
}

@keyframes sf-fly-by-3 {
  from {
    transform: translateZ(-1800px);
    opacity: 0.5;
  }

  to {
    transform: translateZ(-1200px);
    opacity: 0.5;
  }
}

.tabs{
  display: flex;
  flex-direction: column;
  width: 200px;
  align-self: center;
}
.box-center{
  align-self: center;
  display: flex;
  flex-direction: row;
}
.App {
  width: 100%;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,oDAAoD,EAAE,oBAAoB;EAC1E,6BAA6B;EAC7B,qBAAqB;EACrB,kBAAkB,EAAE,qCAAqC;AAC3D;;AAEA,0CAA0C;;AAE1C;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,8CAA8C;AAC9C;;EAEE,YAAY;EACZ,gBAAgB;EAChB,iDAAiD;AACnD;;AAEA,6BAA6B;AAC7B;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,mCAAmC;;AAEnC,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,WAAW;AACb;;AAEA,iEAAiE;AACjE;EACE,qBAAqB;EACrB;AACF;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA,kDAAkD;AAClD;EACE,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE;IACE,6BAA6B;IAC7B,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,YAAY;EACd;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,6BAA6B;IAC7B,YAAY;EACd;AACF;;AAEA;EACE;IACE,8BAA8B;IAC9B,YAAY;EACd;;EAEA;IACE,8BAA8B;IAC9B,YAAY;EACd;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* Định dạng cho phần tiêu đề */\nh1 {\n  color: #333;\n  font-size: 28px;\n  margin-bottom: 20px;\n  text-align: center;\n  /* Căn giữa tiêu đề */\n}\n.gradient-text {\n  background: linear-gradient(45deg, #ff5733, #96a2ff); /* Gradient colors */\n  -webkit-background-clip: text;\n  background-clip: text;\n  color: transparent; /* Đặt màu chữ trở thành trong suốt */\n}\n\n/* Định dạng cho phần chính của ứng dụng */\n\n.centered-box {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: 0;\n  width: 100%;\n}\n\n/* Định dạng cho trường nhập liệu */\ninput[type=\"file\"] {\n  padding: 10px;\n  border: 1px solid #ccc;\n  margin-bottom: 10px;\n  max-width: 400px;\n  /* Giới hạn độ rộng của trường nhập liệu */\n}\n\n/* Định dạng cho các trường nhập liệu và nút */\nTextField,\nButton {\n  margin: 10px;\n  max-width: 400px;\n  /* Giới hạn độ rộng của trường nhập liệu và nút */\n}\n\n/* Định dạng cho nút \"Xuất\" */\nButton {\n  background-color: #0073e6;\n  color: #fff;\n  font-size: 16px;\n  padding: 10px 20px;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  /* Hiệu ứng chuyển đổi màu nền */\n}\n\nButton:hover {\n  background-color: #005bbb;\n  /* Màu nền khi di chuột qua nút */\n}\n\n/* Định dạng cho trường nhập liệu */\n\n/* Định dạng cho nội dung của các trường nhập liệu */\n.MuiInputBase-input {\n  padding: 10px;\n  border: 1px solid #ccc;\n}\n\n/* Định dạng cho nhãn của trường nhập liệu */\n.MuiInputLabel-root {\n  color: #333;\n}\n\n/* Định dạng cho đường viền khi trường nhập liệu được tập trung */\n.Mui-focused {\n  border-color: #0073e6;\n  e: \\Nodejs + React\\Front-End - Copy\\.env\n}\n\n/* Thiết lập kiểu cho phần giới tính */\n.gender {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n}\n\n/* Thiết lập kiểu cho danh sách sản phẩm của Nam */\n.male {\n  border-radius: 10px;\n  background-color: #b3e0ff;\n  border: 1px solid #3498db;\n  padding: 10px;\n  margin: 5px;\n  text-align: center;\n  width: 500;\n}\n\n.male h2 {\n  color: #3498db;\n  margin: -10px;\n  margin-bottom: -20px;\n}\n\n.male ul {\n  list-style-type: none;\n  padding: 0;\n}\n\n@keyframes sf-fly-by-1 {\n  from {\n    transform: translateZ(-600px);\n    opacity: 0.5;\n  }\n\n  to {\n    transform: translateZ(0);\n    opacity: 0.5;\n  }\n}\n\n@keyframes sf-fly-by-2 {\n  from {\n    transform: translateZ(-1200px);\n    opacity: 0.5;\n  }\n\n  to {\n    transform: translateZ(-600px);\n    opacity: 0.5;\n  }\n}\n\n@keyframes sf-fly-by-3 {\n  from {\n    transform: translateZ(-1800px);\n    opacity: 0.5;\n  }\n\n  to {\n    transform: translateZ(-1200px);\n    opacity: 0.5;\n  }\n}\n\n.tabs{\n  display: flex;\n  flex-direction: column;\n  width: 200px;\n  align-self: center;\n}\n.box-center{\n  align-self: center;\n  display: flex;\n  flex-direction: row;\n}\n.App {\n  width: 100%;\n  height: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
